<template>
  <button
    :class="buttonClass"
    :disabled="disabled"
    @click="onClick && onClick()"
  >
    <i :class="iconClass" />
    <span v-text="children" />
  </button>
</template>

<script>
import { css, cx } from "emotion";
import * as refer from "../../statics/refer";

export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    children: {
      type: String,
      default: ""
    },
    onClick: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass() {
      const wrapper = css`
        margin: 0 0.12em;
        padding: 0 0.24em;
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;

        i {
          display: block;
          margin-bottom: 0.12em;
          font-size: 100%;
        }
        span {
          display: block;
          font-size: 25%;
        }

        &:active {
          transform: scale(0.95);
        }

        &:hover {
          color: var(${refer.THEME_ASSIST});
        }
      `;
      const disabled_style = css`
        &,
        &:hover {
          color: #cccccc;
        }

        cursor: not-allowed;
      `;
      return cx(wrapper, { [disabled_style]: this.disabled });
    },
    iconClass() {
      return `zwicon-${this.icon}`;
    }
  }
};
</script>
